module.exports = __webpack_public_path__ + "img/sub6.9030db70.jpg";